import React, {Component} from "react";
import {Modal, Button, Form, Input} from 'antd';
import axios from 'axios';
import { osintRequestAddress } from '../config'

export default class PersonAddModal extends Component {
    formRef = React.createRef()

    handleSave=(event)=>{      
        const token = localStorage.getItem('token')
        // 提交数据
        axios.post(`${osintRequestAddress}/person`,{
            "en_name":event.en_name,
            "cn_name":event.cn_name,
            "screenName": event.twitter?event.twitter.replace("https://twitter.com/","").replace("https://www.twitter.com/",""):"",
            "country": event.country,
            "state": event.state,
            "party": event.party,
            "occupation": event.occupation,
            "wiki": event.wiki,
            "gnTopic": event.gntopic?event.gntopic.replace("https://news.google.com/topics/","https://news.google.com/rss/topics/"):"",
            "thumbImage": event.image,
            headers: {
                'Authorization': token,
            },
        }).then(
                response =>{
                    this.formRef.current.resetFields()
                    this.props.handleModalShow()
                },
                error => {
                    console.log("error",error)
                    this.props.handleModalShow()
                }
        )    
    }

    onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };

    render(){
        return (
            <Modal title="添加人物" maskClosable={false} width={1000} visible={this.props.isModalOpen} onCancel={this.props.handleModalShow}
                footer={null}>
                <Form ref={this.formRef} labelCol={{span: 6}} wrapperCol={{span: 16}} onFinish={this.handleSave} onFinishFailed={this.onFinishFailed} autoComplete="off">
                    <Form.Item  label="英文名" name="en_name"><Input /></Form.Item>
                    <Form.Item  label="中文名" name="cn_name"><Input /></Form.Item>
                    <Form.Item  label="国家（地区）" name="country"><Input /></Form.Item>
                    <Form.Item  label="所在州" name="state"><Input /></Form.Item>
                    <Form.Item  label="政党" name="party"><Input /></Form.Item>
                    <Form.Item  label="职务" name="occupation"><Input /></Form.Item>
                    <Form.Item  label="照片URL" name="image"><Input /></Form.Item>
                    <Form.Item  label="wikiURL" name="wiki"><Input /></Form.Item>
                    <Form.Item  label="twitterURL" name="twitter"><Input /></Form.Item>
                    <Form.Item  label="GoogleNewsTopic" name="gntopic"><Input /></Form.Item>
                    <Form.Item wrapperCol={{offset: 20,span: 4}}><Button type="primary" htmlType="submit">提交</Button></Form.Item>
                </Form>
            </Modal>
        )
    }
}